export const formatDocumentType = (documentTypeModel) => {
  const attributes = {};
  const relationships = {};
  const id = documentTypeModel.id && documentTypeModel.id !== 'dummy' ? documentTypeModel.id : undefined;
  if (documentTypeModel.name) {
    attributes.title = documentTypeModel.name;
  }
  if (documentTypeModel.parent) {
    relationships.parent = { data: { id: documentTypeModel.parent, type: 'node--document_type' } };
  } else {
    relationships.parent = { data: null };
  }
  return {
    id,
    type: 'node--document_type',
    attributes,
    relationships,
  };
};

export const formatFile = (fileModel) => {
  const attributes = {};
  const relationships = {};
  const id = fileModel.id && fileModel.id !== 'dummy' ? fileModel.id : undefined;
  // if (fileModel.title) {
  //   attributes.title = fileModel.title;
  // } else {
  //   attributes.title = fileModel.url;
  // }
  if ('url' in fileModel) {
    attributes.url = fileModel.url;
  }
  if ('data' in fileModel) {
    attributes.uri = fileModel.data;
  }
  if ('filename' in fileModel) {
    attributes.filename = fileModel.filename;
  }
  if ('filemime' in fileModel) {
    attributes.filemime = fileModel.filemime;
  }
  if ('filesize' in fileModel) {
    attributes.filesize = fileModel.filesize;
  }
  return {
    id,
    type: 'file--file',
    attributes,
    relationships,
  };
};

export const formatFile2 = (fileModel, user) => {
  const attributes = {};
  const relationships = {
    uid: {
      data: {
        type: 'user--user',
        id: user.uuid,
      },
    },
  };
  // if (fileModel.title) {
  //   attributes.title = fileModel.title;
  // } else {
  //   attributes.title = fileModel.uri;
  // }
  if ('data' in fileModel) {
    attributes.data = fileModel.data;
  }
  if ('uri' in fileModel) {
    attributes.uri = fileModel.uri;
  }
  return {
    type: fileModel.type ? fileModel.type : 'file--document',
    attributes,
    relationships,
  };
};

export const formatDocument = (documentModel) => {
  const attributes = {};
  const relationships = {};
  const id = documentModel.id && documentModel.id !== 'dummy' ? documentModel.id : undefined;
  if (documentModel.title) {
    attributes.title = documentModel.title;
  } else {
    attributes.title = documentModel.commentary;
  }
  if ('comment' in documentModel) {
    attributes.commentary = documentModel.commentary;
  }
  if ('needed' in documentModel) {
    attributes.needed = documentModel.needed;
  }
  if (documentModel.file && 'id' in documentModel.file) {
    relationships.file = {
      data: {
        id: documentModel.file.id,
        type: documentModel.file.type ? documentModel.file.type : 'file--document',
      },
    };
  }
  if ('documentType' in documentModel && 'id' in documentModel.documentType) {
    relationships.document_type = {
      data: {
        id: documentModel.documentType.id,
        type: 'node--document_type',
      },
    };
  }
  if ('documentNeeded' in documentModel && 'id' in documentModel.documentNeeded) {
    relationships.document_needed = {
      data: {
        id: documentModel.documentNeeded.id,
        type: 'node--document',
      },
    };
  }
  return {
    id,
    type: 'node--document',
    attributes,
    relationships,
  };
};

export const processDocumentType = (document) => {
  const { attributes, relationships, id, type } = document;
  const typeModel = { id, type };
  if ('title' in attributes) {
    typeModel.name = attributes.title;
  }
  if ('parent' in relationships && relationships.parent.data && relationships.parent.data.id) {
    typeModel.parent = relationships.parent.data.id;
  } else {
    typeModel.parent = null;
  }
  return typeModel;
};

export const processFile = (file) => {
  const { attributes, id, type } = file;
  const fileModel = { id, type };
  if ('title' in attributes) {
    fileModel.title = attributes.title;
  }
  if ('url' in attributes) {
    fileModel.url = attributes.url;
  }
  if ('uri' in attributes) {
    fileModel.data = attributes.uri;
  }
  if ('filename' in attributes) {
    fileModel.filename = attributes.filename;
  }
  if ('filemime' in attributes) {
    fileModel.filemime = attributes.filemime;
  }
  if ('filesize' in attributes) {
    fileModel.filesize = attributes.filesize;
  }
  return fileModel;
};

export const processDocument = (document, included) => {
  const { attributes, relationships, id, type } = document;
  const documentModel = { id, type };
  if ('title' in attributes) {
    documentModel.title = attributes.title;
  }
  if ('commentary' in attributes) {
    documentModel.comment = attributes.commentary;
  }
  if ('needed' in attributes) {
    documentModel.needed = attributes.needed;
  }
  if ('file' in relationships && relationships.file.data && relationships.file.data.id) {
    if (included && included.file && included.file.id === relationships.file.data.id) {
      documentModel.file = included.file;
    } else {
      documentModel.file = { id: relationships.file.data.id, type: 'file--file' };
    }
  }
  if ('document_type' in relationships && relationships.document_type.data && relationships.document_type.data.id) {
    if (included && included.documentType && included.documentType.id === relationships.document_type.data.id) {
      documentModel.documentType = included.documentType;
    } else {
      documentModel.documentType = { id: relationships.document_type.data.id, type: 'node--document_type' };
    }
  }
  if ('document_needed' in relationships && relationships.document_needed.data && relationships.document_needed.data.id) {
    if (included && included.documentNeeded && included.documentNeeded.id === relationships.document_needed.data.id) {
      documentModel.documentNeeded = included.documentNeeded;
    } else {
      documentModel.documentNeeded = { id: relationships.document_needed.data.id, type: 'node--document' };
    }
  }
  return documentModel;
};

export const processDocumentIncluded = (document, included) => {
  const { relationships } = document;
  let file = null;
  let documentType = null;
  let documentNeeded = null;
  if (included && included.length > 0) {
    included.forEach((rel) => {
      if (rel.type === 'file--file' || rel.type === 'file--document' || rel.type === 'file--image') {
        if (relationships && relationships.file &&
          relationships.file.data &&
          relationships.file.data.id === rel.id) {
          file = processFile(rel);
        }
      }
      if (rel.type === 'node--document_type') {
        if (relationships && relationships.document_type &&
          relationships.document_type.data &&
          relationships.document_type.data.id === rel.id) {
          documentType = processDocumentType(rel);
        }
      }
      if (rel.type === 'node--document') {
        if (relationships && relationships.document_needed &&
          relationships.document_needed.data &&
          relationships.document_needed.data.id === rel.id) {
          documentNeeded = processDocument(rel);
        }
      }
    });
    return { file, documentType, documentNeeded };
  }
  return null;
};

export const processDocumentTypeResponse = (res) => {
  if (res.data.meta) {
    return res.data.data.map(documentType => processDocumentType(documentType));
  }
  return processDocumentType(res.data.data);
};

export const processFileResponse = (res) => {
  if (res.data.meta) {
    return res.data.data.map(file => processFile(file));
  }
  return processFile(res.data.data);
};

export const processDocumentResponse = (res) => {
  if (res.data.meta) {
    return res.data.data.map(document =>
      processDocument(document, processDocumentIncluded(document, res.data.included)));
  }
  return processDocument(res.data.data, processDocumentIncluded(res.data.data, res.data.included));
};



// WEBPACK FOOTER //
// ./src/features/documents/utils.js